import React, { Fragment } from "react";
import { connect } from "react-redux";

const GiftCourseResultItem = ({
  user: {
    _id,
    role,
    avatar,
    channelid,
    firstname,
    lastname,
    jobtitle,
    location,
  },
  setUser,
}) => {
  return (
    <Fragment>
      <div
        className="hero-search-results"
        onClick={() =>
          setUser({
            _id,
            role,
            avatar,
            channelid,
            firstname,
            lastname,
            jobtitle,
            location,
          })
        }
      >
        <div className="profile-drop-container">
          <div className="onlive-avi-container">
            <div
              className={`avi-color-border-mini${
                role === "mentor" ? "red" : "green"
              }`}
            >
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                className="mini-avi"
                alt="miniavi"
              />
            </div>
          </div>
          <ul className="user-online-items">
            <li className="user-online-item-mini">
              <span
                className={`${
                  role === "mentor" ? "red" : "green"
                } name-font-mini bold`}
              >
                {channelid}
              </span>
            </li>
            <li className="user-online-item-mini">
              <span
                className={`${
                  role === "mentor" ? "red" : "green"
                } name-font-mini bold`}
              >
                {firstname} {lastname}
              </span>
            </li>
            <li className="user-online-item-mini">{jobtitle}</li>
            <li className="user-online-item-mini">
              {location.city}, {location.state}
            </li>
          </ul>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {})(GiftCourseResultItem);
